import { render, staticRenderFns } from "./AuthTab.vue?vue&type=template&id=ed21a4ba&scoped=true&lang=pug&"
import script from "./AuthTab.vue?vue&type=script&lang=ts&"
export * from "./AuthTab.vue?vue&type=script&lang=ts&"
import style0 from "./AuthTab.vue?vue&type=style&index=0&id=ed21a4ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed21a4ba",
  null
  
)

export default component.exports